import React, { useEffect } from 'react';
import './ElfsightWidget.css'

export const ElfsightWidget = () => {

    useEffect(() => {
        const scriptId = "elfsight-platform-script";
        if (!document.getElementById(scriptId)) {
            const script = document.createElement("script");
            script.src = "https://apps.elfsight.com/p/platform.js";
            script.id = scriptId;
            script.defer = true;
            document.body.appendChild(script);
            script.onload = () => {
                setTimeout(() => {
                    const container = document.querySelector(
                        ".elfsight-app-77ad5fb7-320c-4dd1-af9e-e80b4f36ec1b"
                    );
                    if (container) {
                        container.style.height = `${container.offsetHeight}px`;
                    }
                }, 1000);
            };
        }
    }, []);

    return (
        <div className="widget-container">
            <div
                className="elfsight-app-77ad5fb7-320c-4dd1-af9e-e80b4f36ec1b"
                data-elfsight-app-lazy
            ></div>
        </div>
    )
}